// extracted by mini-css-extract-plugin
module.exports = {"button":"Button_button__1OhAW","primary":"Button_primary__hmNf8","secondary":"Button_secondary__2lQ1P","icon":"Button_icon__2ODqE"};